/**
 * StudioLayout — 사용자 앱 셸
 *
 * Phone: 하단 탭 바 (BottomNav)
 * Tablet/Desktop: 상단 헤더 (StudioHeader)
 */

import { useEffect } from 'react'
import { Outlet } from 'react-router'
import { BottomNav } from './BottomNav.js'
import { StudioHeader } from './StudioHeader.js'
import { useAIJobStore } from '../../stores/aiJobStore.js'
import { startBackgroundPolling, isBackgroundPolling } from '../../lib/backgroundJobPoller.js'
import styles from './StudioLayout.module.css'

export function StudioLayout() {
  // 앱 시작 시 미완료 백그라운드 job 폴링 재개 (새로고침 복구)
  useEffect(() => {
    const store = useAIJobStore.getState()
    store.pruneStaleJobs()
    const activeJobs = store.getActiveJobs()
    for (const job of activeJobs) {
      if (!job.jobId || job.jobId === 'undefined') {
        store.removeJob(job.jobId)
        continue
      }
      if (!isBackgroundPolling(job.jobId)) {
        startBackgroundPolling(job.jobId)
      }
    }
  }, [])

  return (
    <div className={styles.root}>
      <StudioHeader />
      <main className={styles.content}>
        <Outlet />
      </main>
      <BottomNav />
    </div>
  )
}
